import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/**
 * Shown when the session could not be checked (rate limit, server error,
 * network). The user is probably still logged in, so the action is a retry,
 * not a login (RUI-13).
 */
export function SessionUnavailable() {
  const { t } = useTranslation(['common']);
  return (
    <div role="alert" className="min-h-screen flex flex-col items-center justify-center gap-3 p-6 text-center bg-background">
      <p className="text-base font-medium text-foreground">{t('common:sessionUnavailable.title')}</p>
      <p className="max-w-sm text-sm text-muted-foreground">{t('common:sessionUnavailable.body')}</p>
      <Button onClick={() => window.location.reload()}>{t('common:sessionUnavailable.retry')}</Button>
    </div>
  );
}
